import React from 'react';

/**
 * NoIndex — tells Google (and other bots) NOT to index the current page.
 *
 * Use on every authenticated / private / utility page (dashboard, settings,
 * forgot-password, admin, etc.) so they don't leak into search results.
 *
 * Uses React 19's native support for hoisting <meta> tags into <head>.
 *
 *   import { NoIndex } from '../components/SEO/NoIndex';
 *   <>
 *     <NoIndex />
 *     ...the rest of the page...
 *   </>
 */
export const NoIndex = () => (
    <>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
    </>
);

export default NoIndex;
